import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import { coverScores } from "./BlogCover.logic";
import styles from "./BlogCover.module.css";

type Props = {
  seed: number;
};

export default function BlogCoverScores(props: Props) {
  const { seed } = props;
  const T = useT();

  return (
    <span className={styles.scores}>
      {coverScores(seed).map((score) => (
        <span key={score.labelKey} className={styles.score}>
          <span className={styles.scoreLabel}>{T(score.labelKey)}</span>
          <span className={styles.dots}>
            {score.dots.map((dot) => (
              <span
                key={dot.id}
                className={UStyles.classNames(
                  styles.dot,
                  dot.isFilled ? styles[score.toneClass] : "",
                )}
              />
            ))}
          </span>
        </span>
      ))}
    </span>
  );
}
